import { render, staticRenderFns } from "./FormIPT.vue?vue&type=template&id=49dcd196"
import script from "./FormIPT.vue?vue&type=script&lang=js"
export * from "./FormIPT.vue?vue&type=script&lang=js"
import style0 from "./FormIPT.vue?vue&type=style&index=0&id=49dcd196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports